import { render, staticRenderFns } from "./PostingActivityReport.vue?vue&type=template&id=10d5be31&"
import script from "./PostingActivityReport.vue?vue&type=script&lang=js&"
export * from "./PostingActivityReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports